import React from "react";
import "./about.css";

/* ===== DATA OBJECT ===== */
const aboutUsData = {
  title: "ग्रामपंचायत गोंडी दिग्रस: प्रगतीचा संकल्प",
  intro:
    "गोंडीदिग्रस काटोल तालुक्यात असलेले, संस्कृती आणि कृषीचे उत्तम मिश्रण असलेले गाव आहे. स्थानिक स्वराज्य संस्था म्हणून आम्ही, गोंडीदिग्रस एक आदर्श, आत्मनिर्भर आणि तंत्रज्ञान-स्नेही गाव बनवण्यासाठी कटिबद्ध आहोत.",

  pdf: "/images/pdf.pdf",   // ✅ PDF add केली

  visionTitle: "💡 आमची दृष्टी (Our Vision)",
  vision: [
    {
      icon: "🌐",
      title: "डिजिटल ग्राम",
      description:
        "ग्रामपंचायतीचे कामकाज पारदर्शक आणि डिजिटल माध्यमांतून चालवणे.",
    },
    {
      icon: "🌿",
      title: "पर्यावरण पूरक विकास",
      description:
        "गावातील स्वच्छता, पाणी व्यवस्थापन आणि नैसर्गिक संसाधनांचे संरक्षण करणे.",
    },
    {
      icon: "🤝",
      title: "युवा आणि महिला सबलीकरण",
      description:
        "शिक्षण, आरोग्य आणि रोजगाराच्या संधी उपलब्ध करून तरुण आणि महिलांना सशक्त करणे.",
    },
  ],

  servicesTitle: "🏗 सेवा आणि सुविधा",
  services: [
    "पायाभूत सुविधा: उत्तम रस्ते, २४x७ पाणीपुरवठा आणि सार्वजनिक बांधकाम.",
    "दाखले आणि नोंदी: जन्म-मृत्यू, रहिवासी आणि विविध शासकीय दाखले.",
    "शासकीय योजना: केंद्र व राज्य योजनांचा लाभ लाभार्थ्यांपर्यंत पोहोचवणे.",
  ],

  participation: {
    heading: "🤝 तुमचा सहभाग महत्त्वाचा",
    content:
      "ग्रामपंचायत म्हणजे केवळ कार्यालय नव्हे; ती गावकऱ्यांची संस्था आहे. ग्रामसभेद्वारे गावाच्या विकासात सर्वांचा सहभाग आवश्यक आहे.",
  },

  events: {
    title: "🌹 संविधान दिन व ग्रामसफाई अभियान 🌹",
    description: `ग्रामपंचायत गोंडी दिग्रस येथे कार्यक्रम आयोजित करण्यात आला...`,
  },

  sarpanch: {
    name: "श्रीमती. मंदाताई सुरेंद्र महंत",
    slogan: "👉 'प्रत्येक नागरिकाच्या आवाजाला महत्त्व'",
    message:
      "ग्रामपंचायतीचे दरवाजे प्रत्येक नागरिकासाठी खुले असून कारभार जनता-केंद्रित आहे.",
    closing:
      "गोंडी दिग्रसच्या विकासासाठी नागरिकांचा विश्वास हीच आमची खरी ताकद आहे.",
  },
};

/* ===== REUSABLE COMPONENT ===== */
const VisionItem = ({ icon, title, description }) => (
  <div className="vision-card">
    <div className="vision-icon">{icon}</div>
    <h4>{title}</h4>
    <p>{description}</p>
  </div>
);

/* ===== MAIN COMPONENT ===== */
const AboutUs = () => {
  return (
    <div className="page about-us-page">
      <header className="page-header">
        <h1>{aboutUsData.title}</h1>
        <p>{aboutUsData.intro}</p>
      </header>

      <main className="page-content-grid">

        {/* Vision */}
        <section className="section">
          <h2>{aboutUsData.visionTitle}</h2>
          <div className="vision-cards-container">
            {aboutUsData.vision.map((item, i) => (
              <VisionItem key={i} {...item} />
            ))}
          </div>
        </section>

        {/* Services */}
        <section className="section">
          <h2>{aboutUsData.servicesTitle}</h2>
          <ul>
            {aboutUsData.services.map((s, i) => (
              <li key={i}>{s}</li>
            ))}
          </ul>
        </section>

        {/* Participation */}
        <section className="section bg-light">
          <h3>{aboutUsData.participation.heading}</h3>
          <p>{aboutUsData.participation.content}</p>
        </section>

        {/* Event */}
        <section className="section events-section bg-light">
          <h3>{aboutUsData.events.title}</h3>
          <p>{aboutUsData.events.description}</p>
        </section>

        {/* Sarpanch */}
        <section className="section">
          <h2>सन्माननीय सरपंच: {aboutUsData.sarpanch.name}</h2>
          <p>{aboutUsData.sarpanch.slogan}</p>
          <p>{aboutUsData.sarpanch.message}</p>
        </section>

        {/* ✅ PDF SECTION (NEW ADD) */}
{/* ✅ PDF SECTION */}


      </main>

      <footer className="page-footer">
        <p>*** {aboutUsData.sarpanch.closing} ***</p>
      </footer>
    </div>
  );
};

export default AboutUs;